enum DateComplexType {
    ExactDate = 1,
    ConstantDate = 2,
    Period = 3,
    PathValue = 4
}

export default DateComplexType;